// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-info[data-v-7ad74d96]{align-items:center;display:flex;flex-direction:row;gap:10px}.article-info__date[data-v-7ad74d96],.article-info__min-read[data-v-7ad74d96]{font-size:13px;--tw-text-opacity:1;color:#9797a6;color:rgba(151,151,166,var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
